import { useSelector } from 'react-redux';

import { useFeatureFlag } from './useFeatureFlag';
import { jsonStringToObject } from '../utils/common';
import { isSupportOrAdminUser } from '../utils/user';

export function useFeatureFlagPermissionsBySupplier(featureFlag) {
  const { user: currentUser, supplierId: currentSupplierId } = useSelector((state) => state.role);
  const allowedSuppliersForProductsFeed = useFeatureFlag(featureFlag, JSON.stringify([]));
  const parsedSuppliers = jsonStringToObject(allowedSuppliersForProductsFeed, []) || [];

  const isCymbioUser = isSupportOrAdminUser(currentUser?.role);
  const isProductsFeedEnabledBySupplier = parsedSuppliers.includes(currentSupplierId);

  return { isEnabled: isCymbioUser || isProductsFeedEnabledBySupplier };
}
